module.exports = __webpack_public_path__ + "media/images/responsive/page_common/search_icons/store-30477b75c6f0c6838480c1bb20f66a75.svg";